export const isAuthenticated = () =>
    localStorage.getItem(process.env.REACT_APP_TOKEN_KEY) !== null &&
    localStorage.getItem(process.env.REACT_APP_TOKEN_KEY) !== "";

export const getToken = () =>
    localStorage.getItem(process.env.REACT_APP_TOKEN_KEY);

export const login = (token) => {
    localStorage.setItem(process.env.REACT_APP_TOKEN_KEY, token);
};

export const logout = () => {
    localStorage.removeItem(process.env.REACT_APP_TOKEN_KEY);
    localStorage.removeItem(process.env.REACT_APP_NOME_KEY);
    localStorage.removeItem(process.env.REACT_APP_EMAIL_KEY);
    localStorage.removeItem(process.env.REACT_APP_PERFIL_KEY);
    localStorage.removeItem(process.env.REACT_APP_CONFIG_PORTAL_KEY);
    localStorage.clear();
};
